import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Typography, Result } from 'antd';
import { ArrowLeftOutlined, LockOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { NS } from '../i18n';
import './Unauthorized.css';

const { Title, Text } = Typography;

export function Unauthorized() {
  const { t } = useTranslation(NS);
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-2);
  };

  return (
    <div className="unauthorized-container">
      <div className="unauthorized-content">
        <Button 
          type="link" 
          icon={<ArrowLeftOutlined />} 
          onClick={handleGoBack}
          className="back-button"
        >
          {t('unauthorized.goBack')}
        </Button>
        
        <Result
          icon={<LockOutlined className="unauthorized-icon" />}
          title={<Title level={2}>{t('unauthorized.title')}</Title>}
          subTitle={
            <Text type="secondary">
              {t('unauthorized.message')}
            </Text>
          }
          extra={
            <Button 
              type="primary" 
              onClick={handleGoBack}
              className="unauthorized-button"
            >
              {t('unauthorized.goBack')}
            </Button>
          }
        />
      </div>
    </div>
  );
} 